import React, { useEffect, useRef, useState } from 'react';
import { ColorTokens, SizeTypeTokens, } from '@voltmoney/schema';
import { WebView as WV } from 'react-native-webview';
import { ActivityIndicator, Dimensions, Platform, View, KeyboardAvoidingView, StyleSheet, Linking, Keyboard } from 'react-native';
import { InAppBrowser } from 'react-native-inappbrowser-reborn';
import ThemeProvider from '@voltmoney/theme';
import { _getUiWindow } from '../stack/utils';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
};
const WebView = ({ uri, isOpenInNewTab = false, metaData, iframe = false, width, height, shouldScroll, isHeightDynamic, eventId, eventAction, triggerAction, isBordered, pgTrackingId, authToken, showBillDesk, billDeskCancelAction, navigateHandleAction, isFromKYC, isFromPayment, mfHeight, enableIncognito, showPrincipalRepayment, onLoadCompleteAction, doFormPost = false, errorTataPaymentAction, }) => {
    const theme = ThemeProvider.getTheme();
    const [iFrameHeight, setIframeHeight] = useState();
    const [iframeLoading, setIframeLoading] = useState(true);
    const [webHeight, setWebHeight] = useState(Dimensions.get('window').height + 30);
    const [webViewHeight, setWebViewHeight] = useState(mfHeight ? mfHeight : Dimensions.get('window').height);
    const [showBillLoading, setShowBillLoading] = useState(true);
    const [showWebLoading, setShowWebLoading] = useState(true);
    const [showWebviewContentLoader, setShowWebviewContentLoader] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const webViewRef = React.useRef(null);
    const webViewScript = `
  setTimeout(function() { 
    window.postMessage(document.documentElement.scrollHeight); 
  }, 500);
  true; // note: this is required, or you'll sometimes get silent failures
`;
    const avatarRef = useRef();
    const firstLineRef = useRef();
    const secondLineRef = useRef();
    const thirdLineRef = useRef();
    const htmlContent = `
        <html>
        <body onload="document.forms[0].submit()">
            <form method="POST" action="https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment">
                <input type="hidden" name="msg" value="${uri}" />
            </form>
        </body>
        </html>
    `;
    const handleIframeMessage = async (event) => {
        // Handle the received message from the iframe
        const iframeDimensionData = event.data;
        if (iframeDimensionData && iframeDimensionData?.id === "getDimensionLeads") {
            console.log('Received message from iframe:', iframeDimensionData, typeof iframeDimensionData);
            const height = iframeDimensionData?.data?.height;
            setIframeHeight(height);
            // changeIframeHeight(height);
        }
        else if (iframeDimensionData && iframeDimensionData?.id === eventId) {
            console.log('Received message from iframe2 :', eventId, iframeDimensionData, typeof iframeDimensionData);
            eventAction &&
                await triggerAction({
                    ...eventAction,
                    payload: {
                        ...eventAction.payload,
                        data: iframeDimensionData
                    }
                });
        }
    };
    useEffect(() => {
        if (Platform.OS === 'web') {
            window.addEventListener('message', handleIframeMessage);
            // Clean up the event listener when the component unmounts
            return () => {
                window.removeEventListener('message', handleIframeMessage);
            };
        }
        setTimeout(() => {
            setShowWebLoading(false);
        }, 5000);
        setTimeout(() => {
            setShowBillLoading(false);
        });
    }, []);
    if (isOpenInNewTab) {
        //openInNewTab(uri);
        return (React.createElement(View, { style: {
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement(ActivityIndicator, { color: theme.colors[ColorTokens.Primary_100], size: theme.space[SizeTypeTokens.Size32] })));
    }
    const deviceHeight = Dimensions.get('window').height;
    const deviceWidth = Dimensions.get('window').width;
    const onMessage = (event) => {
        billDeskCancelAction && triggerAction(billDeskCancelAction);
    };
    const responseHandler = () => {
    };
    const openFallbackUPILink = async (url) => {
        try {
            const isAvailable = await InAppBrowser.isAvailable();
            if (isAvailable) {
                await InAppBrowser.open(url, {
                    toolbarColor: '#6200EE',
                    secondaryToolbarColor: 'black',
                    showTitle: true,
                    forceCloseOnRedirection: false,
                });
            }
            else {
                console.error('Error opening browser UPI link:');
            }
        }
        catch (error) {
            console.error('Error opening fallback UPI link:', error);
        }
    };
    const onShouldStartLoadWithRequest = (event) => {
        const { url } = event;
        console.warn("EVENT RECEIVED IS", event);
        if (url.includes("showFlexi") || url === "https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false") {
            billDeskCancelAction && triggerAction(billDeskCancelAction);
            return false;
        }
        else {
            if (url.startsWith("upi://") || url.includes("upi://") || url.includes("tez") || url.includes("paytmmp") || url.includes("phonepe") || url.includes("credpay") || url.includes("bhim")) {
                try {
                    const supported = Linking.canOpenURL(url);
                    if (supported) {
                        Linking.openURL(url);
                        Keyboard.dismiss();
                    }
                    else {
                        webViewRef.current?.loadUrl(event.navigationAction.request.url);
                        // openFallbackUPILink(url)
                    }
                }
                catch (error) {
                    console.error('Error opening start UPI link:');
                }
                return false;
            }
            else {
                return true;
            }
        }
    };
    const renderLoader = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement(ActivityIndicator, { color: theme.colors[ColorTokens.Primary_100], size: theme.space[SizeTypeTokens.Size32] })));
    };
    const renderWebView = () => {
        return showBillLoading ? renderLoader() : (React.createElement(View, { style: [
                styles.container,
                { height: height }
            ] },
            React.createElement(WV, { containerStyle: { height: height, width: '100%' }, style: { height: height, width: '100%' }, scalesPageToFit: false, originWhitelist: ['*'], useWebKit: true, onShouldStartLoadWithRequest: () => {
                    console.warn("URL RECEIVED IS");
                    return true;
                }, onNavigationStateChange: (event) => {
                    console.warn("CURRENT URL IS", event);
                }, ref: webViewRef, source: {
                    html: ` 
          <html>
<body>
<script type="module" src="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js"></script>
<script type="nomodule" src="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk.js"></script>
<link href="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css" rel="stylesheet">

<script type="text/javascript">

         const config = {
                            responseHandler: function (result) {
 setTimeout(()=> {

     sendDataToReactNativeApp(result)
                },(1000))
                                
     
            },
                            merchantLogo: "",
                            flowConfig: {
    merchantId: "BDUATV2K07",
  bdOrderId :"${pgTrackingId}",
  authToken : "${authToken}"  ,
  childWindow : false,
   retryCount: 3,
                            prefs: {"payment_categories": ["card","nb"]}
    },
                            flowType: "payments"
                        }
                        
                            setTimeout(()=> {
                        loadBillDeskSdk(config)
   
                },(5000))
                        
                          
           const sendDataToReactNativeApp = async (data) => {
                window.ReactNativeWebView.postMessage(data);
              };

      </script>
      
</body>
</html>
`,
                }, onMessage: onMessage, javaScriptEnabled: true, javaScriptEnabledAndroid: true, javaScriptCanOpenWindowsAutomatically: true, allowFileAccess: true, domStorageEnabled: true, mixedContentMode: 'always', mediaPlaybackRequiresUserAction: false, allowsInlineMediaPlayback: true }),
            showWebLoading && renderLoader()));
    };
    const _ShimmerReact = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                height: 300,
                // borderWidth: 1,
                // borderColor: 'red',
                flexDirection: 'column',
                padding: 16,
            } },
            React.createElement(View, { style: {
                    flexDirection: "column",
                    width: '100%',
                    height: '100%',
                    padding: 16,
                    backgroundColor: '#F9FAFB'
                } },
                React.createElement(ShimmerPlaceholder, { ref: avatarRef, 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        borderRadius: 8,
                        height: 100
                    } }),
                React.createElement(ShimmerPlaceholder, { ref: firstLineRef, 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        height: 12,
                        marginTop: 28,
                        borderRadius: 8,
                    } }),
                React.createElement(ShimmerPlaceholder, { ref: secondLineRef, 
                    // stopAutoRun
                    style: {
                        width: '75%',
                        height: 12,
                        marginTop: 28,
                        borderRadius: 8,
                    } }),
                React.createElement(ShimmerPlaceholder, { ref: thirdLineRef, 
                    // stopAutoRun
                    style: {
                        width: '50%',
                        height: 12,
                        marginTop: 28,
                        borderRadius: 8,
                    } }))));
    };
    if (iframe && isBordered) {
        return (React.createElement(View, { style: {
                width: '100%',
                height: iFrameHeight,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: '#E4E7EC',
                backgroundColor: '#FFF',
                shadowColor: '#000',
                shadowOffset: {
                    width: 0,
                    height: 3,
                },
                shadowOpacity: 0.1,
                shadowRadius: 12,
                elevation: 3, // for Android
            } },
            iframeLoading &&
                React.createElement(React.Fragment, null, _ShimmerReact()),
            React.createElement("iframe", { src: uri, width: width ? width : '100%', onLoad: () => setIframeLoading(false), allow: "camera", height: iframeLoading ? 0 :
                    isHeightDynamic
                        ? iFrameHeight
                        : height
                            ? height
                            : deviceHeight - 15, frameBorder: 0, scrolling: shouldScroll ? "no" : "yes", style: {
                    visibility: iframeLoading ? 'hidden' : 'visible',
                } }, ' ')));
    }
    if (iframe) {
        return (React.createElement("iframe", { src: uri, width: width ? width : '100%', allow: "camera", height: isHeightDynamic
                ? iFrameHeight
                : height
                    ? height
                    : deviceHeight - 15, frameBorder: 0, scrolling: shouldScroll ? "no" : "yes", 
            // style= {
            // 	shouldScroll ? {overflow:"hidden"}: {}
            // }
            onLoad: () => {
                onLoadCompleteAction &&
                    triggerAction(onLoadCompleteAction);
            }, style: shouldScroll ? { overflow: "hidden" } : {} }, ' '));
    }
    const handleNavigationStateChange = (navState) => {
        const { url } = navState;
        try {
            if (url.includes("KYCCancel")) {
                return triggerAction({
                    ...navigateHandleAction,
                    payload: {
                        value: "KYC_CANCELLED"
                    }
                });
            }
            else if (url.includes("close-on-open")) {
                return triggerAction({
                    ...navigateHandleAction,
                    payload: {
                        value: "KYC_POPUP_CLOSED"
                    }
                });
            }
        }
        catch (e) { }
    };
    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', () => {
            setWebViewHeight(Platform.OS === 'ios'
                ? Dimensions.get('window').height - 100
                : Platform.OS === 'android'
                    ? Dimensions.get('window').height - 100
                    : Dimensions.get('window').height);
        });
        const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
            setWebViewHeight(Platform.OS === 'ios'
                ? Dimensions.get('window').height - 100
                : Platform.OS === 'android'
                    ? Dimensions.get('window').height - 100
                    : Dimensions.get('window').height);
        });
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);
    const handleNavigationStateChangePayment = async (navState) => {
        const { url } = navState;
        if (url.startsWith("upi://") || url.includes("upi://")) {
            try {
                const supported = await Linking.canOpenURL(url);
                if (supported) {
                    await Linking.openURL(url);
                    Keyboard.dismiss();
                }
                else {
                    console.error('Error opening UPI link:');
                }
            }
            catch (error) {
                console.error('Error opening UPI link:');
            }
        }
    };
    const renderFormPost = () => {
        return (React.createElement(View, { style: { flex: 1 } },
            isLoading && (React.createElement(View, { style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                } },
                React.createElement(ActivityIndicator, { color: theme.colors[ColorTokens.Primary_100], size: theme.space[SizeTypeTokens.SIZE_46] }))),
            React.createElement(View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center' } },
                React.createElement(WV, { id: "iframe", ref: webViewRef, style: {
                        width: metaData?.widthScreen || deviceWidth,
                        height: mfHeight ? mfHeight : webViewHeight,
                    }, automaticallyAdjustContentInsets: false, javaScriptEnabled: true, domStorageEnabled: true, startInLoadingState: false, useWebKit: true, originWhitelist: ['*'], allowsInlineMediaPlayback: true, scalesPageToFit: Platform.OS === 'android', scrollEnabled: true, onShouldStartLoadWithRequest: onShouldStartLoadWithRequest, onNavigationStateChange: handleNavigationStateChangePayment, javaScriptEnabledAndroid: true, mediaPlaybackRequiresUserAction: false, source: { html: htmlContent }, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== 'web', incognito: enableIncognito, mixedContentMode: "always", onLoadStart: () => {
                        setIsLoading(true);
                    }, onLoadEnd: () => {
                        setIsLoading(false);
                    } }))));
    };
    const handleNativeError = async (syntheticEvent) => {
        const { nativeEvent } = syntheticEvent;
        if (errorTataPaymentAction) {
            await triggerAction({
                ...errorTataPaymentAction,
                payload: {
                    type: 'TATA_PAYMENT_NATIVE_ERROR',
                    ...errorTataPaymentAction.payload,
                }
            });
        }
    };
    const handleHttpError = async (syntheticEvent) => {
        const { nativeEvent } = syntheticEvent;
        if (errorTataPaymentAction) {
            await triggerAction({
                ...errorTataPaymentAction,
                payload: {
                    type: 'TATA_PAYMENT_HTTP_ERROR',
                    ...errorTataPaymentAction.payload,
                }
            });
        }
    };
    const handleWebViewStartLoad = async () => {
        await triggerAction({
            ...errorTataPaymentAction,
            payload: {
                type: 'TATA_PAYMENT_WEBVIEW_LOAD_START',
                ...errorTataPaymentAction.payload,
            }
        });
    };
    const handleWebViewEndLoad = async () => {
        await triggerAction({
            ...errorTataPaymentAction,
            payload: {
                type: 'TATA_PAYMENT_WEBVIEW_LOAD_END',
                ...errorTataPaymentAction.payload,
            }
        });
    };
    const currentTime = new Date().getTime() / 1000;
    const renderPrincipalRepayment = () => {
        return (React.createElement(View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center' } },
            React.createElement(WV, { key: currentTime, id: 'iframe', ref: webViewRef, style: {
                    width: metaData?.widthScreen || _getUiWindow(deviceWidth),
                    height: mfHeight ? mfHeight : webViewHeight,
                    alignSelf: 'center',
                }, automaticallyAdjustContentInsets: false, javaScriptEnabled: true, domStorageEnabled: true, startInLoadingState: true, useWebKit: true, originWhitelist: ['*'], allowsInlineMediaPlayback: true, scalesPageToFit: Platform.OS === 'android', scrollEnabled: true, onShouldStartLoadWithRequest: onShouldStartLoadWithRequest, onNavigationStateChange: handleNavigationStateChangePayment, javaScriptEnabledAndroid: true, mediaPlaybackRequiresUserAction: false, source: { uri: uri }, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web", incognito: true, mixedContentMode: "always", onError: handleNativeError, onHttpError: handleHttpError, onLoadStart: handleWebViewStartLoad, onLoadEnd: handleWebViewEndLoad })));
    };
    return doFormPost ? renderFormPost() : showPrincipalRepayment ? renderPrincipalRepayment() : showBillDesk ? renderWebView() : isFromKYC ? (React.createElement(KeyboardAvoidingView, { enabled: Platform.OS === 'android', behavior: 'padding', keyboardVerticalOffset: 90, style: {
            width: metaData.widthScreen ||
                _getUiWindow(deviceWidth),
            height: Platform.OS === 'ios'
                ? webViewHeight - 170
                : Platform.OS === 'android'
                    ? webViewHeight - 200
                    : webViewHeight
        } },
        React.createElement(WV, { id: 'iframe', ref: webViewRef, style: {
                width: metaData?.widthScreen || _getUiWindow(deviceWidth),
                height: Platform.OS === 'ios'
                    ? webViewHeight - 100
                    : Platform.OS === 'android'
                        ? webViewHeight - 50
                        : webViewHeight,
                paddingBottom: 20,
            }, automaticallyAdjustContentInsets: false, javaScriptEnabled: true, domStorageEnabled: true, startInLoadingState: true, useWebKit: true, originWhitelist: ['*'], allowsInlineMediaPlayback: true, scalesPageToFit: Platform.OS === 'android', scrollEnabled: true, onShouldStartLoadWithRequest: onShouldStartLoadWithRequest, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, source: { uri: uri }, onNavigationStateChange: handleNavigationStateChange, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== 'web', incognito: enableIncognito }))) : (React.createElement(WV, { id: 'iframe', ref: webViewRef, style: {
            width: metaData.widthScreen || _getUiWindow(deviceWidth),
            height: mfHeight ? mfHeight : webViewHeight
        }, automaticallyAdjustContentInsets: false, javaScriptEnabled: true, domStorageEnabled: true, startInLoadingState: true, useWebKit: true, originWhitelist: ['*'], allowsInlineMediaPlayback: true, scalesPageToFit: Platform.OS === 'android', scrollEnabled: true, onShouldStartLoadWithRequest: onShouldStartLoadWithRequest, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, source: { uri: uri }, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web", incognito: enableIncognito }));
};
export default React.memo(WebView);
export { WebView };
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 50
    },
    successLottie: { width: 70, height: 'auto' },
    body: {
        paddingHorizontal: 16,
        paddingTop: 24
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: '#FFF',
        padding: 16
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionLeftCardContainer: {
        flex: 3,
        display: 'flex',
        flexDirection: 'row',
    },
    transactionRightCardContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    webview: {
        flex: 1,
    },
    headerStyle: { width: '100%', flex: 1 },
});
